<template>
  <div class="coupon">
    <div class="title">恭喜你，获得了价值88元幸运大礼包</div>
    <div class="item" v-for="item in sendCouponList" :key="item.id">
      <CouponItem
        gradient
        :item="{ ...item.coupon, ...item }"
        buttonText="使用"
        @click="handleUseCoupon({ ...item.coupon, ...item })"
      />
    </div>

    <div @click="handleOpenVip">
      <img
        src="https://oss.1cece.top/static/backend/images/vip.jpg"
        class="footer-img"
      />
    </div>

    <div class="save-coupon-button">
      <van-button @click="handleSaveCoupon" color="#8BC34A" round block
        >保存优惠券</van-button
      >
    </div>
  </div>

  <WeChatQr v-model:show="wechatQrVisible" :title="qrModalTexts.title">
    <template #subhead>
      <p class="subhead">
        {{ qrModalTexts.subhead }}
      </p>
    </template>
    <span> {{ qrModalTexts.content }}</span>
  </WeChatQr>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getGoodsOrderCoupon } from "@/api/report";
import WeChatQr from "@/components/WeChatQr";
import CouponItem from "@/components/CouponItem";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
const wechatQrVisible = ref(false);
const qrModalTexts = ref({});
const sendCouponList = ref([]);
// 保存优惠券
function handleSaveCoupon() {
  wechatQrVisible.value = true;
  qrModalTexts.value = {
    title: "大礼包已保存至公众号",
    subhead: "请关注后进入个人中心查看",
  };
}
const { paper_order_sn, coupon_code } = route.query;
async function init() {
  const { data } = await getGoodsOrderCoupon({
    paper_order_sn,
  });
  sendCouponList.value = data;
}
function handleOpenVip() {
  router.push({
    path: "/vipOpened",
    query: { coupon_code },
  });
}

function handleUseCoupon({ code, coupon_type, send_code, coupon }) {
  switch (coupon_type) {
    case 2:
      if (send_code) {
        // 赠送券且已有send_code 跳转赠送页
        router.push({
          path: "/giveDetail",
          query: { send_code },
        });
      } else {
        router.push({
          path: "/couponUse",
          query: { coupon_code: code },
        });
      }
      break;
    case 4:
      // VIP折扣券跳转会员开通
      router.push({
        path: "/vipOpened",
        query: { coupon_code: code },
      });
      break;

    default:
      const { goods_ids } = coupon;
      //只有一条商品直接跳转商品详情页
      if (goods_ids.length === 1) {
        const [goods] = goods_ids;
        router.push({
          path: "/goods",
          query: {
            guid: goods.guid,
            coupon_code: code,
          },
        });
      } else {
        router.push({
          path: "/couponUse",
          query: { coupon_code: code },
        });
      }

      break;
  }
}

onMounted(() => {
  init();
});
</script>

<style lang="less" scoped>
.coupon {
  padding: 40px 0;
  background-color: #ffecd2;
  min-height: 100vh;
  .footer-img {
    width: 100%;
    display: block;
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #ff4a4a;
    padding-bottom: 16px;
    text-align: center;
  }

  .item {
    margin-bottom: 12px;
    padding: 0 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .save-coupon-button {
    padding: 10px;
  }
}
.subhead {
  font-size: 20px;
  color: @theme-color;
}
</style>
